export default {
  ANNUAL_TRIAL_PACKAGE: 'annual_trial_package',
  FREE_COM_DOMAIN: 'free_com_domain',
  NO_DISCOUNTS: 'no_discounts',
};
